import React from 'react'
import Blik from '@assets/img/payment_icons/ico-blik.svg'
import BlikPP from '@assets/img/payment_icons/ico-blik-pp.svg'
import TPay from '@assets/img/payment_icons/ico-bank-przelew.svg'
import GPay from '@assets/img/payment_icons/ico-g-pay.svg'
import ApplePay from '@assets/img/payment_icons/ico-jablko.svg'
import PayPo from '@assets/img/payment_icons/ico-paypo.svg'
import PayPal from '@assets/img/payment_icons/ico-paypal.svg'
import VisaMc from '@assets/img/payment_icons/ico-visa-mc.svg'
import PaymentMethod from './PaymentMethod'

const PaymentMethods = ({ paymentMethod, setPaymentMethod, t }) => {
    return (
        <div className="trip-reservation__payment-methods">
            <PaymentMethod
                paymentMethod={paymentMethod}
                setPaymentMethod={setPaymentMethod}
                paymentType="tpay"
                icon={TPay}
                name={t('online-transfer')}
                desc={t('online-transfer-desc')}
            />
            <PaymentMethod
                paymentMethod={paymentMethod}
                setPaymentMethod={setPaymentMethod}
                icon={VisaMc}
                paymentType="card"
                name={t('card-payment')}
                desc={t('card-payment-desc')}
            />
            <PaymentMethod
                paymentMethod={paymentMethod}
                setPaymentMethod={setPaymentMethod}
                icon={Blik}
                paymentType="blik"
                name={t('blik')}
                desc={t('blik-desc')}
            />
            <PaymentMethod
                paymentMethod={paymentMethod}
                setPaymentMethod={setPaymentMethod}
                icon={BlikPP}
                paymentType="blik-pp"
                name={t('blik-later')}
                desc={t('blik-later-desc')}
            />
            <PaymentMethod
                paymentMethod={paymentMethod}
                setPaymentMethod={setPaymentMethod}
                icon={PayPo}
                paymentType="paypo"
                name={t('pay-later')}
                desc={t('pay-later-desc')}
            />
            <PaymentMethod
                paymentMethod={paymentMethod}
                setPaymentMethod={setPaymentMethod}
                icon={GPay}
                paymentType="google-pay"
                name={t('google-pay')}
                desc={t('google-pay-desc')}
            />
            <PaymentMethod
                paymentMethod={paymentMethod}
                setPaymentMethod={setPaymentMethod}
                icon={ApplePay}
                paymentType="apple-pay"
                name={t('apple-pay')}
                desc={t('apple-pay-desc')}
            />
            <PaymentMethod
                paymentMethod={paymentMethod}
                setPaymentMethod={setPaymentMethod}
                icon={PayPal}
                paymentType="paypal"
                name={t('paypal')}
                desc={t('paypal-desc')}
            />
        </div>
    )
}

export default PaymentMethods
